import script from "./CardDepartments.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDepartments.vue?vue&type=script&setup=true&lang=js"

import "../styles/_departments.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__